import type React from 'react';

import { parseHtml } from '@change-corgi/core-react/html';

import { C } from '../ActionAlertEmailPreview/styles';

import type { EditorialMembershipPreviewData } from './types';

type Block = NonNullable<EditorialMembershipPreviewData['contentBlocks']>[number];

function isPrimaryLink(link: string): boolean {
	try {
		const url = new URL(link);
		return (
			(url.hostname === 'change.org' || url.hostname.endsWith('.change.org')) &&
			(url.pathname.startsWith('/sign') || url.pathname.startsWith('/member'))
		);
	} catch {
		return false;
	}
}

export const ContentBlockItem: React.FC<{ block: Block; isFirstCta: boolean }> = ({ block, isFirstCta }) => {
	const primary = block.buttonLink ? isFirstCta || isPrimaryLink(block.buttonLink) : false;

	return (
		<>
			{block.image && (
				<div style={{ marginBottom: 12 }}>
					{block.imageLink ? (
						<a href={block.imageLink} target="_blank" rel="noreferrer">
							<img src={block.image} alt="" style={{ width: '100%', display: 'block' }} />
						</a>
					) : (
						<img src={block.image} alt="" style={{ width: '100%', display: 'block' }} />
					)}
				</div>
			)}
			{block.text && <div style={{ fontSize: 14, lineHeight: 1.6, marginBottom: 12 }}>{parseHtml(block.text)}</div>}
			{block.buttonLink && (
				<div style={{ textAlign: 'center', padding: '12px 0' }}>
					<span
						style={{
							display: 'block',
							padding: '16px 24px',
							backgroundColor: primary ? C.primaryBtn : C.white,
							color: C.text,
							fontFamily: C.font,
							fontSize: 18,
							fontWeight: 700,
							borderRadius: 8,
							border: `1px solid ${primary ? C.primaryBtn : C.muted}`,
							boxSizing: 'border-box',
							cursor: 'default',
						}}
					>
						{block.buttonCopy || block.buttonLink}
					</span>
				</div>
			)}
		</>
	);
};
